jQuery(document).ready(function ($) {
  $("#transactions-csv").click(function (e) {
    e.preventDefault();

    var postsData = [];

    // Function to clean whitespace
    function cleanWhitespace(text) {
      return text.replace(/\s+/g, " ").trim();
    }

    // Collect the post data
    $(".transactions--article").each(function () {
      var post = {
        date:
          '"' +
          cleanWhitespace(
            $(this)
              .find(".transactions--article--date p")
              .text()
              .replace(/"/g, '""')
          ) +
          '"',
        status:
          '"' +
          cleanWhitespace(
            $(this)
              .find(".transactions--article--status p")
              .text()
              .replace(/"/g, '""')
          ) +
          '"',
        transaction:
          '"' +
          cleanWhitespace(
            $(this)
              .find(".transactions--article--title p")
              .text()
              .replace(/"/g, '""')
          ) +
          '"',
        value:
          '"' +
          cleanWhitespace(
            $(this)
              .find(".transactions--article--value p")
              .text()
              .replace(/"/g, '""')
          ) +
          '"',
      };
      postsData.push(post);
    });

    // Convert data to CSV with custom headers
    var csvContent = "data:text/csv;charset=utf-8,";
    csvContent += "Announcement Date,Status,Transaction,Value (M)\n";

    postsData.forEach(function (post) {
      csvContent +=
        post.date +
        "," +
        post.status +
        "," +
        post.transaction +
        "," +
        post.value +
        "\n";
    });

    // Create a download link and click it
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Transactions.csv");
    document.body.appendChild(link);
    link.click();
  });
});
